"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _channel = _interopRequireDefault(require("../channel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Abstract = /*#__PURE__*/function () {
  function Abstract() {
    _classCallCheck(this, Abstract);

    if (this.constructor === Abstract) {
      throw new TypeError("Can not construct abstract class.");
    }

    this.channels = {};
  }

  _createClass(Abstract, [{
    key: "createChannel",
    value: function createChannel(topic) {
      var channel = new _channel["default"](topic, this);
      this.channels[topic] = channel;
      return channel;
    }
  }, {
    key: "ready",
    value: function ready() {
      throw new TypeError("Do not call abstract method foo from child.");
    }
  }, {
    key: "messageDecode",
    value: function messageDecode(message) {
      return message;
    }
  }, {
    key: "send",
    value: function send() {
      throw new TypeError("Do not call abstract method foo from child.");
    }
  }, {
    key: "on",
    value: function on() {
      throw new TypeError("Do not call abstract method foo from child.");
    }
  }, {
    key: "off",
    value: function off() {
      throw new TypeError("Do not call abstract method foo from child.");
    }
  }]);

  return Abstract;
}();

exports["default"] = Abstract;